"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Save = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var NoResults = function () { return react_1.default.createElement(storybook_1.Forms.NoResults, { title: 'Deze playlist bevat nog geen video\'s', description: 'Ga naar video bewerken om deze aan een playlist toe te voegen.' }); };
var Main = function (_a) {
    var user = _a.user, channel = _a.channel, name = _a.name, id = _a.id;
    var _b = ra_fetch_1.useApi('backend').index('videos', {
        channel_id: channel.id,
        category: name,
        tags: true,
        resource: 'VideoFull'
    }), videos = _b[0], setVideos = _b[1];
    var _c = ra_fetch_1.useApi('backend')
        .records(setVideos, videos.data, 'video_id', 'id')
        .delete('playlists.videos.delete', {
        id: id,
        channel_id: channel.id
    }), deleteVideo = _c[0], submitDeleteVideo = _c[1];
    if (!videos.loading && !videos.data.length) {
        return react_1.default.createElement(NoResults, null);
    }
    return react_1.default.createElement(storybook_1.Videos.List, { user: user, videos: videos, channel: channel, onDelete: function (video) { return submitDeleteVideo({ video_id: video.id }); }, simple: true });
};
var Save = function (_a) {
    var user = _a.user, channel = _a.channel, id = _a.id;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1], closeModal = _b[2];
    var _c = storybook_1.Helpers.useSave('backend', 'playlists', {
        id: null,
        channel_id: channel.id,
        label: '',
        description: '',
        name: '',
        hidden: false,
    }, {
        id: id,
        channel_id: channel.id
    }), playlist = _c[0], setPlaylist = _c[1], savePlaylist = _c[2];
    function onSubmit(values, disableAlert) {
        return savePlaylist(values).then(function (response) {
            if (!response.errors.length && !disableAlert) {
                var modalMessage_1 = id ? 'Je playlist is succesvol opgeslagen' : 'Je playlist is succesvol aangemaakt';
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: modalMessage_1, returnUrl: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/playlists", onClose: id ? closeModal : undefined }); }
                });
            }
        });
    }
    if (playlist.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (id && !playlist.data.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Forms.Form, null,
            react_1.default.createElement(storybook_1.Layouts.ContainerWithSidebar, { className: 'storybook-layouts-space' },
                react_1.default.createElement(storybook_1.Layouts.Sidebar, null,
                    react_1.default.createElement(storybook_1.Cards.Card, null,
                        react_1.default.createElement(storybook_1.Cards.Content, null,
                            react_1.default.createElement(storybook_1.Playlists.FormStatus, { value: playlist.data.hidden, onChange: function (hidden) {
                                    if (playlist.data.id) {
                                        return onSubmit({ hidden: hidden }, true).then(function () { return setPlaylist({ hidden: hidden }); });
                                    }
                                    setPlaylist({ hidden: hidden });
                                } }),
                            react_1.default.createElement(storybook_1.Playlists.FormFields, { playlist: playlist.data, setPlaylist: setPlaylist }),
                            react_1.default.createElement(storybook_1.Texts.Small, null, "Zet de playlist op publiek om deze beschikbaar te maken op Eyecons.com."),
                            react_1.default.createElement(storybook_1.Forms.Buttons, { loading: playlist.submitting, errors: playlist.errors, submit: onSubmit })))),
                react_1.default.createElement(storybook_1.Layouts.Main, null,
                    playlist.data.name && react_1.default.createElement(Main, { user: user, channel: channel, name: playlist.data.name, id: id }),
                    !id && react_1.default.createElement(NoResults, null))))));
};
exports.Save = Save;
exports.Save.propTypes = {
    /**
     * Current channel
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * Playlist ID for editing.
     */
    id: prop_types_1.default.number,
};
exports.Save.defaultProps = {
    id: null,
};
